import React, { useEffect, useRef, useState } from 'react';
import styled, { keyframes } from 'styled-components';
import moment from 'moment-timezone';
import { useDispatch } from 'react-redux';
import {liveHandler} from '../store/liveNumSlice';
import {io} from "socket.io-client";
import { getMethod } from '../Apis/apis';
import Marquee from "react-fast-marquee";
import {FaSortUp,FaSortDown} from 'react-icons/fa';

const ContainerDiv = styled.div`
   padding: 50px 20px;
   background-color: ${props => props.theme.primary};
   position: relative;
`
const TextBlink = keyframes`
    50% {
        opacity: 1;
    }
    57% {
        opacity: 0;
    }
    64% {
        opacity: 1;
    }
    71% {
        opacity: 0;
    }
    78% {
        opacity: 1;
    }
`

const LiveNumber = styled.h1`
   text-align: center;
   user-select: none;
   color: ${props => props.theme.fontColor};
   font-size: 70px;
   font-weight: bolder;
   text-shadow: 0 4.36px 8.896px #353535, 0 -2px 1px #fff;
   margin-bottom: 10px;
`
const LiveNumberAnimation = styled.h1`
   text-align: center;
   user-select: none;
   color: ${props => props.theme.fontColor};
   font-size: 70px;
   font-weight: bolder;
   text-shadow: 0 4.36px 8.896px #353535, 0 -2px 1px #fff;
   margin-bottom: 10px;
   animation: ${TextBlink} 4s linear infinite;
`

const UpdateTime = styled.div`
   margin: 0;
   font-size: 14px;
   color: ${props => props.theme.fontColor};
   font-weight: 600;
   text-align: center;
   margin-bottom: 0;
   user-select: none;
`

const SetValueContainer = styled.div`
   display: flex;
   justify-content: space-between;
   align-items: flex-end;
`
const LiveCard = styled.div`
    color: ${props => props.theme.fontColor};
    display: flex;
    flex-direction: column;
    border-radius: 12px;
    user-select: none;
    width: 100px;
    span {
        font-size: 15px;
        font-weight: 500;
    }
    p {
        font-size: 15px;
        margin-top: 0px;
        font-weight: 600;
        margin-bottom: 0;
    }
`

const LiveSetValue = styled.p`
    animation: ${TextBlink} 4s linear infinite;
`
let currentDate = moment().tz("Asia/Yangon").format("DD-MMMM-YYYY");

const Livethreed = () => {
    const [hourTime,setHourTime] = useState("--");
    const [minuteTime,setMinuteTime] = useState("--");
    const [secondTime,setSecondTime] = useState("--");
    const [animate13,setAnimate13] = useState(false);
    const [animate,setAnimate] = useState(false);
    const [set,setSet] = useState("--");
    const [value,setValue] = useState("--");
    const [result,setResult] = useState("--");
    const [message,setMessage] = useState("");
    const [coinsValue,setCoinsValue] = useState([]);
    const [lastResult,setLastResult] = useState([]);
    const [tenHalf,setTenHalf] = useState(null);
    const [twoHalf,setTwoHalf] = useState(null);
    const [seven,setSeven] = useState(null);
    const [eight,setEight] = useState(null);
    const [nine,setNine] = useState(null);
    const [valueTen,setValueTen] = useState(null);
    const [valueTwoHalf,setValueTwoHalf] = useState(null);
    const [valueSeven,setValueSeven] = useState(null);
    const [valueEight,setValueEight] = useState(null);
    const [valueNine,setValueNine] = useState(null);
    const [serverTime,setServerTime] = useState("");
    const dispatch = useDispatch();
    let temp = [];
    let date = moment().tz("Asia/Yangon").format("YYYY-MM-DD");
    useEffect(()=>{
        const socket = io(`${process.env.REACT_APP_HOST}/time`);
        socket.connect();
        socket.on("STime", res => {
            setServerTime(res)
            return () => {
                socket.disconnect();
            };
        });
    },[]);

    useEffect(()=>{
        const socket = io(`${process.env.REACT_APP_HOST}/live3d`);
            socket.connect();
            socket.on("live3d", async res => {
                let timeRes = await getMethod(`/number/time`);
                if(timeRes){
                    if(timeRes.con){
                        if(timeRes.data > "08:00:00" && timeRes.data < "13:44:58"){
                            if(res){
                                setSet(res.set);
                                setValue(res.value);
                                setResult(res.result);
                                dispatch(liveHandler(res.result));
                            }
                        };
        
                        if(timeRes.data > "13:50:00" && timeRes.data < "20:59:58"){
                            if(res){
                                setSet(res.set);
                                setValue(res.value);
                                setResult(res.result);
                                dispatch(liveHandler(res.result));
                            }
                        };
                    };
                };
            });
            return () => {
            socket.disconnect();
        };
    },[]);

    useEffect(()=>{
        const socket = io(`${process.env.REACT_APP_HOST}/watch`);
        socket.connect();
        socket.on("watch", res => {
            setCoinsValue(res);
        });
        return () => {
            socket.disconnect();
        };
      },[]);

    useEffect(()=>{
        let temHalf = "08:00:00";
        let endNine = "20:59:58";
        if(serverTime > "13:44:59" && serverTime < "13:49:59"){
            (async()=>{
                let res = await getMethod(`/number3d/filter?date=${date}`);
                if(res){
                    if(res.data.length > 0){
                        res.data.map(el => {
                            if(el.time === "01:45 PM"){
                                setSet(el.set);
                                setValue(el.value);
                                setResult(el.result);
                            }
                        })
                    }
                }
                
            })();
        };
        if(serverTime > "20:59:59" && serverTime < "23:59:59"){
            (async()=>{
                let res = await getMethod(`/number3d/filter?date=${date}`);
                if(res){
                    if(res.data.length > 0){
                        res.data.map(el => {
                            if(el.time === "01:45 PM"){
                                setSet(el.set);
                                setValue(el.value);
                                setResult(el.result);
                            }
                        })
                    }
                }
                
            })();
        };

        if(serverTime > temHalf && serverTime < "13:44:58"){
            setAnimate13(true);
        }else{
            setAnimate13(false);
        }

        if (serverTime > "13:50:00" && serverTime < endNine){
            setAnimate(true);
        }else{
            setAnimate(false);
        };
    },[serverTime]);
    
    const chunk = num => {
        let str = num.toString().split('.');
        if (str[0].length >= 4) {
            str[0] = str[0].replace(/(\d)(?=(\d{3})+$)/g, '$1,');
        }
        if (str[1] && str[1].length >= 5) {
            str[1] = str[1].replace(/(\d{3})/g, '$1 ');
        }
        return str.join('.');
    };

    useEffect(()=>{
        (async()=>{
           const res = await getMethod('/alert');
           if(res){
             if(res.data){
               setMessage(res.data);
             }
           };
            })();
    },[]);

    useEffect(()=>{
         if(coinsValue.length > 0){
            coinsValue.map(el => {
                if(el.code === 'BTC'){
                    if(serverTime > "10:29:46" && serverTime < "10:29:58"){
                        (async ()=>{
                            let res = await getMethod('/custom');
                            if(res.con){
                                if(res.coinsValue){
                                    if(res.coinsValue.length > 0){
                                        res.coinsValue.map(timeValue => {
                                            if(timeValue.time === "10:30 AM"){
                                                setTenHalf(timeValue);
                                            };
                                        });
                                    }else{
                                        setTenHalf(null);
                                    }
                                };
                            };
                        })();
                        if(tenHalf){
                            el.rate = (Math.round(el.rate * 100) / 100).toFixed(2).split(".")[0]+"."+(Math.round(el.rate * 100) / 100).toFixed(2).split(".")[1].slice(0,-1)+tenHalf.result[0];
                        }else{
                            el.rate = (Math.round(el.rate * 100) / 100).toFixed(2);
                        }
                    }else{
                        el.rate = (Math.round(el.rate * 100) / 100).toFixed(2);
                    }
                    
                    if(serverTime > "14:29:46" && serverTime < "14:29:58"){
                        (async ()=>{
                            let res = await getMethod('/custom');
                            if(res.con){
                                if(res.coinsValue){
                                    if(res.coinsValue.length > 0){
                                        res.coinsValue.map(timeValue => {
                                            if(timeValue.time === "02:30 PM"){
                                                setTwoHalf(timeValue);
                                            };
                                        });
                                    }else{
                                        setTwoHalf(null);
                                    }
                                };
                            };
                        })();
                        if(twoHalf){
                            el.rate = (Math.round(el.rate * 100) / 100).toFixed(2).split(".")[0]+"."+(Math.round(el.rate * 100) / 100).toFixed(2).split(".")[1].slice(0,-1)+twoHalf.result[0];
                        }else{
                            el.rate = (Math.round(el.rate * 100) / 100).toFixed(2);
                        };
                    }else{
                        el.rate = (Math.round(el.rate * 100) / 100).toFixed(2);
                    }
                    
                    if(serverTime > "18:59:46" && serverTime < "18:59:58"){
                        (async ()=>{
                            let res = await getMethod('/custom');
                            if(res.con){
                                if(res.coinsValue){
                                    if(res.coinsValue.length > 0){
                                        res.coinsValue.map(timeValue => {
                                            if(timeValue.time === "07:00 PM"){
                                                setSeven(timeValue);
                                            };
                                        });
                                    }else{
                                        setSeven(null);
                                    }
                                };
                            };
                        })();
                        if(seven){
                            el.rate = (Math.round(el.rate * 100) / 100).toFixed(2).split(".")[0]+"."+(Math.round(el.rate * 100) / 100).toFixed(2).split(".")[1].slice(0,-1)+seven.result[0];
                        }else{
                            el.rate = (Math.round(el.rate * 100) / 100).toFixed(2);
                        };
                    }else{
                        el.rate = (Math.round(el.rate * 100) / 100).toFixed(2);
                    }
                    
                    if(serverTime > "19:59:46" && serverTime < "19:59:58"){
                        (async ()=>{
                            let res = await getMethod('/custom');
                            if(res.con){
                                if(res.coinsValue){
                                    if(res.coinsValue.length > 0){
                                        res.coinsValue.map(timeValue => {
                                            if(timeValue.time === "08:00 PM"){
                                                setEight(timeValue);
                                            };
                                        });
                                    }else{
                                        setEight(null);
                                    }
                                };
                            };
                        })();
                        if(eight){
                            el.rate = (Math.round(el.rate * 100) / 100).toFixed(2).split(".")[0]+"."+(Math.round(el.rate * 100) / 100).toFixed(2).split(".")[1].slice(0,-1)+eight.result[0];
                        }else{
                            el.rate = (Math.round(el.rate * 100) / 100).toFixed(2);
                        };
                    }else{
                        el.rate = (Math.round(el.rate * 100) / 100).toFixed(2);
                    }
                    
                    if(serverTime > "20:59:46" && serverTime < "20:59:58"){
                        (async ()=>{
                            let res = await getMethod('/custom');
                            if(res.con){
                                if(res.coinsValue){
                                    if(res.coinsValue.length > 0){
                                        res.coinsValue.map(timeValue => {
                                            if(timeValue.time === "09:00 PM"){
                                                setNine(timeValue);
                                            };
                                        });
                                    }else{
                                        setNine(null);
                                    }
                                };
                            };
                        })();
                        if(nine){
                            el.rate = (Math.round(el.rate * 100) / 100).toFixed(2).split(".")[0]+"."+(Math.round(el.rate * 100) / 100).toFixed(2).split(".")[1].slice(0,-1)+nine.result[0];
                        }else{
                            el.rate = (Math.round(el.rate * 100) / 100).toFixed(2);
                        };
                    }else{
                        el.rate = (Math.round(el.rate * 100) / 100).toFixed(2);
                    }
                }
                if(el.code === 'ETH'){
                    if(serverTime > "10:29:46" && serverTime < "10:29:58"){
                        (async ()=>{
                            let res = await getMethod('/custom');
                            if(res.con){
                                if(res.coinsValue){
                                    if(res.coinsValue.length > 0){
                                        res.coinsValue.map(timeValue => {
                                            if(timeValue.time === "10:30 AM"){
                                                setValueTen(timeValue);
                                            };
                                        });
                                    }else{
                                        setValueTen(null);
                                    }
                                };
                            };
                        })();
                        if(valueTen){
                            el.rate = (Math.round(el.rate * 100) / 100).toFixed(2).split(".")[0]+"."+(Math.round(el.rate * 100) / 100).toFixed(2).split(".")[1].slice(0,-1)+valueTen.result[1];
                        }else{
                            el.rate = (Math.round(el.rate * 100) / 100).toFixed(2);
                        }
                    }else{
                        el.rate = (Math.round(el.rate * 100) / 100).toFixed(2);
                    }
                    
                    if(serverTime > "14:29:46" && serverTime < "14:29:58"){
                        (async ()=>{
                            let res = await getMethod('/custom');
                            if(res.con){
                                if(res.coinsValue){
                                    if(res.coinsValue.length > 0){
                                        res.coinsValue.map(timeValue => {
                                            if(timeValue.time === "02:30 PM"){
                                                setValueTwoHalf(timeValue);
                                            };
                                        });
                                    }else{
                                        setValueTwoHalf(null);
                                    }
                                };
                            };
                        })();
                        if(valueTwoHalf){
                            el.rate = (Math.round(el.rate * 100) / 100).toFixed(2).split(".")[0]+"."+(Math.round(el.rate * 100) / 100).toFixed(2).split(".")[1].slice(0,-1)+valueTwoHalf.result[1];
                        }else{
                            el.rate = (Math.round(el.rate * 100) / 100).toFixed(2);
                        };
                    }else{
                        el.rate = (Math.round(el.rate * 100) / 100).toFixed(2);
                    }
                    
                    if(serverTime > "18:59:46" && serverTime < "18:59:58"){
                        (async ()=>{
                            let res = await getMethod('/custom');
                            if(res.con){
                                if(res.coinsValue){
                                    if(res.coinsValue.length > 0){
                                        res.coinsValue.map(timeValue => {
                                            if(timeValue.time === "07:00 PM"){
                                                setValueSeven(timeValue);
                                            };
                                        });
                                    }else{
                                        setValueSeven(null);
                                    }
                                };
                            };
                        })();
                        if(valueSeven){
                            el.rate = (Math.round(el.rate * 100) / 100).toFixed(2).split(".")[0]+"."+(Math.round(el.rate * 100) / 100).toFixed(2).split(".")[1].slice(0,-1)+valueSeven.result[1];
                        }else{
                            el.rate = (Math.round(el.rate * 100) / 100).toFixed(2);
                        };
                    }else{
                        el.rate = (Math.round(el.rate * 100) / 100).toFixed(2);
                    }
                    
                    if(serverTime > "19:59:46" && serverTime < "19:59:58"){
                        (async ()=>{
                            let res = await getMethod('/custom');
                            if(res.con){
                                if(res.coinsValue){
                                    if(res.coinsValue.length > 0){
                                        res.coinsValue.map(timeValue => {
                                            if(timeValue.time === "08:00 PM"){
                                                setValueEight(timeValue);
                                            };
                                        });
                                    }else{
                                        setValueEight(null);
                                    }
                                };
                            };
                        })();
                        if(valueEight){
                            el.rate = (Math.round(el.rate * 100) / 100).toFixed(2).split(".")[0]+"."+(Math.round(el.rate * 100) / 100).toFixed(2).split(".")[1].slice(0,-1)+valueEight.result[1];
                        }else{
                            el.rate = (Math.round(el.rate * 100) / 100).toFixed(2);
                        };
                    }else{
                        el.rate = (Math.round(el.rate * 100) / 100).toFixed(2);
                    }
                    
                    if(serverTime > "20:59:46" && serverTime < "20:59:58"){
                        (async ()=>{
                            let res = await getMethod('/custom');
                            if(res.con){
                                if(res.coinsValue){
                                    if(res.coinsValue.length > 0){
                                        res.coinsValue.map(timeValue => {
                                            if(timeValue.time === "09:00 PM"){
                                                setValueNine(timeValue);
                                            };
                                        });
                                    }else{
                                        setValueNine(null);
                                    }
                                };
                            };
                        })();
                        if(valueNine){
                            el.rate = (Math.round(el.rate * 100) / 100).toFixed(2).split(".")[0]+"."+(Math.round(el.rate * 100) / 100).toFixed(2).split(".")[1].slice(0,-1)+valueNine.result[1];
                        }else{
                            el.rate = (Math.round(el.rate * 100) / 100).toFixed(2);
                        };
                    }else{
                        el.rate = (Math.round(el.rate * 100) / 100).toFixed(2);
                    }
                };
                temp.push(el);
                setLastResult(temp)
            })
        };
    },[coinsValue,serverTime]);

  return (
    <ContainerDiv>
        <Marquee 
            gradient={false}
            style={{
                backgroundColor: "rgb(0 0 0 / 23%)",
                userSelect: 'none',
                padding: '7px',
                fontSize: '14px',
                position: "absolute",
                top: 0,
                left: 0,
                right: 0,
            }}
         >
            {
               lastResult.length > 0 &&
               lastResult.map((value,i) =>
                    <span key={i}>
                        {
                            (value.code === "BTC" && "Taiwan BTC") ||
                            (value.code === "ETH" && "Taiwan ETH") ||
                            value.code
                        }
                        &nbsp;
                        ${
                            value.code === 'BTC' && value.rate
                        }
                        {
                            value.code === 'ETH' && value.rate
                        }
                        {
                            value.code === 'USDT' && (Math.round(value.rate * 100) / 100).toFixed(2)
                        }
                        {
                            value.code === 'USDC' && (Math.round(value.rate * 100) / 100).toFixed(2)
                        }
                        {
                            value.code === 'BNB' && (Math.round(value.rate * 100) / 100).toFixed(2)
                        }
                        {
                            value.code === 'XRP' && (Math.round(value.rate * 1000000) / 1000000).toFixed(6)
                        }
                        {
                            value.code === 'BUSD' && (Math.round(value.rate * 100) / 100).toFixed(2)
                        }
                        {
                            value.code === 'DOGE' && (Math.round(value.rate * 1000000) / 1000000).toFixed(6)
                        }
                        {
                            value.code === 'DAI' && (Math.round(value.rate * 100) / 100).toFixed(2)
                        }
                        {
                            value.code === 'ADA' && (Math.round(value.rate * 1000000) / 1000000).toFixed(6)
                        }
                        <span style={{
                            color: `${
                                (((value.delta.hour - 1) * 100).toFixed(2) > 0 && "#0E9F6E") ||
                                (((value.delta.hour - 1) * 100).toFixed(2) < 0 && "#F05252")
                            }`,
                            fontWeight: 'bolder'
                        }}>
                            &nbsp;{
                                    ((value.delta.hour - 1) * 100) == 0 ? '0':
                                    ((value.delta.hour - 1) * 100).toFixed(2)
                                }%
                                {
                                    (((value.delta.hour - 1) * 100).toFixed(2) > 0 &&
                                    <FaSortUp style={{marginTop: '4px'}} />) ||
                                    (((value.delta.hour - 1) * 100).toFixed(2) < 0 &&
                                    <FaSortDown style={{marginBottom: '4px'}} />)
                                }
                        </span>
                        ,&nbsp;&nbsp;
                    </span>
               )
            }
        </Marquee>
         <SetValueContainer>
             <LiveCard style={{textAlign: 'left'}}>
                 <span>Set</span>
                 {animate13 || animate? <LiveSetValue>{set.includes(".")?chunk(set.split(".")[0])+"."+set.split(".")[1]:set}</LiveSetValue> :<p>{set.includes(".")?chunk(set.split(".")[0])+"."+set.split(".")[1]:set}</p>}
             </LiveCard>
             <div>
                {
                    animate13 || animate ? <LiveNumberAnimation>{result}</LiveNumberAnimation> : <LiveNumber>{result}</LiveNumber>
                }
                <UpdateTime>
                    <div>{currentDate} </div>
                    <div>{serverTime}</div>
                </UpdateTime>
             </div>
             <LiveCard style={{textAlign: 'right'}}>
                 <span>Value</span>
                 {animate13 || animate? <LiveSetValue>{value.includes(".")?chunk(value.split(".")[0])+"."+value.split(".")[1]:value}</LiveSetValue> :<p>{value.includes(".")?chunk(value.split(".")[0])+"."+value.split(".")[1]:value}</p>}
             </LiveCard>
         </SetValueContainer>
         <Marquee 
            speed={40}
            gradient={false}
            style={{
                backgroundColor: "rgb(0 0 0 / 23%)",
                userSelect: 'none',
                padding: '7px',
                fontSize: '14px',
                position: "absolute",
                bottom: 0,
                left: 0,
                right: 0,
            }}
         >
            {message.length === 1 ? message[0].name: "Hello"}
        </Marquee>
    </ContainerDiv>
  )
}

export default Livethreed
